import React from 'react';
import ClearAllIcon from '@mui/icons-material/ClearAll';
import CloseIcon from '@mui/icons-material/Close';
import { Alert, Box, Button, Divider, IconButton, Paper, Stack, Typography } from '@mui/material';

import { closeAllSnackbars, closeSnackbar } from '@paragon/notification-tools';
import { createScrollbarStyling } from '@paragon/themes';

import { getNotificationCenterRelevantSnackbars, toMuiSeverity } from '../../../store/selectors/notificationSelectors';
import { leftSidebarSet } from '../../../store/slices/panelDataSlice';
import { useAppDispatch, useAppSelector } from '../../hooks';

export function NotificationsPanel() {
  const dispatch = useAppDispatch();
  const snackbars = useAppSelector(getNotificationCenterRelevantSnackbars);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, height: '100%' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', paddingTop: 1, paddingX: 1 }}>
        <Typography variant="h6">Notification Center</Typography>

        <Box sx={{ flexGrow: 1 }} />

        <IconButton onClick={() => void dispatch(leftSidebarSet('open'))}>
          <CloseIcon />
        </IconButton>
      </Box>

      <Divider />

      <Button
        sx={{ margin: 1 }}
        variant="outlined"
        startIcon={<ClearAllIcon />}
        disabled={snackbars.length === 0}
        onClick={() => {
          dispatch(closeAllSnackbars());
        }}
      >
        Clear All Notifications
      </Button>

      <Stack
        direction="column"
        spacing={1}
        sx={[
          {
            paddingX: 1,
            minHeight: 0,
            overflowY: 'auto',
          },
          createScrollbarStyling,
        ]}
      >
        {snackbars.map(([message, options]) => (
          <Alert
            key={options.key}
            variant="filled"
            icon={false}
            severity={toMuiSeverity(options.variant)}
            sx={{
              color: 'white',
              backgroundColor: (theme) => theme.palette[toMuiSeverity(options.variant)].dark,
            }}
            onClose={
              // a permanent notification is taken down by whatever raised it, so offer no dismiss button for one
              options.permanent
                ? undefined
                : () => {
                    dispatch(closeSnackbar(options.key));
                  }
            }
          >
            {message}
          </Alert>
        ))}

        {snackbars.length === 0 && (
          <Paper variant="outlined" sx={{ marginTop: 4, padding: 2 }}>
            <Typography align="center" variant="body2">
              No notifications at this time.
            </Typography>
          </Paper>
        )}
      </Stack>
    </Box>
  );
}
